import { Box, Text, ToggleSwitch } from "@vinomofo/components";
import { useEffect, useMemo, useState } from "react";
import {
  RefinementListProvided,
  connectRefinementList,
} from "react-instantsearch-core";

import { ALL_FACETS } from "../instant-search/refinements";
import CurrentFilterItem from "./CurrentFilterItem";
import styled from "styled-components";
import { trackAddRemoveFilterEvent } from "../../utils/event-tracking";
import { useInstantSearch } from "../../hooks/use-instantsearch";
import { useLocation } from "@reach/router";
import { isWhiskymofo } from "../../utils/is-page";

interface FilterOnlyListProps extends RefinementListProvided {
  label: string;
  attribute: string;
  asCurrentFilter?: boolean;
}

const StyledContainer = styled(Box)`
  @media ${({ theme }) => theme.mq.max.mobile} {
    border-bottom: none;
  }
`;

const StyledToggleSwitchBox = styled(Box)`
  overflow: hidden;
  div {
    max-width: 35px !important;
    input {
      &:checked + label:after {
        left: calc(100% - 2px);
      }
    }
    label {
      border-radius: 10px;
      height: 21px;
      &:after {
        top: 1px;
        left: 1px;
        width: 14px;
        height: 14px;
      }
    }
  }
  div:nth-child(2) {
    display: none;
  }
`;

export const FilterOnlyList = connectRefinementList<FilterOnlyListProps>(
  ({
    label,
    items,
    attribute,
    refine,
    currentRefinement,
    asCurrentFilter,
  }: FilterOnlyListProps): JSX.Element => {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const isChecked = (label: string) => currentRefinement.includes(label);
    const [inputValue, setInputValue] = useState<boolean>(true);
    const mapSecret = (attr) => {
      return attr === "secret" ? "black-market" : attr;
    };
    useEffect(() => {
      if (params.get(mapSecret(attribute))) {
        const paramValue = params.get(mapSecret(attribute))
          ? params.get(mapSecret(attribute)) === "true"
          : true;
        setInputValue(paramValue);
      } else {
        setInputValue(true);
      }
    }, [currentRefinement]);

    const {
      setCarryOverFilter,
      carryOverFilter,
      searchState,
    } = useInstantSearch();
    const CURRENT_URL_FILTER = location?.search.replace(/query=[^&]+&?/, "");

    if (CURRENT_URL_FILTER) {
      if (carryOverFilter !== CURRENT_URL_FILTER && location?.search) {
        setCarryOverFilter(CURRENT_URL_FILTER);
      }
    } else setCarryOverFilter(CURRENT_URL_FILTER);

    // if (isWhiskymofo && (label === "Black Market" || label === "Mixed")) {
    //   return <></>;
    // }

    return useMemo(
      () =>
        items.length > 0 && (
          <>
            {asCurrentFilter
              ? items
                  .filter((f) => isChecked(f.label) && f.count > 0)
                  .map((item, i) => (
                    <CurrentFilterItem
                      key={i}
                      label={label}
                      count={item.count}
                      onClick={(event) => {
                        event.preventDefault();
                        trackAddRemoveFilterEvent({
                          eventType: items[0].isRefined ? "remove" : "add",
                          searchState: searchState,
                          filter: {
                            type: attribute,
                            value: items[0].isRefined ? "true" : "false",
                          },
                        });
                        refine(["true"]);
                      }}
                    />
                  ))
              : !location.pathname.includes(
                  ALL_FACETS.find((el) => el.label === label).slug
                ) && (
                  <StyledContainer
                    display={"flex"}
                    padding={"20px"}
                    borderBottom={"1px solid #e2e2e2"}
                  >
                    <Box flex={5}>
                      <Text fontSize={2} fontWeight="500" color="button">
                        {label}
                      </Text>
                    </Box>
                    <StyledToggleSwitchBox>
                      <ToggleSwitch
                        value={items[0]?.isRefined} // get always false option
                        name={attribute}
                        checked={items[0] ? !items[0].isRefined : true} // get always false option
                        onChange={(e) => {
                          e.preventDefault();
                          const stringInputValue = !inputValue;
                          trackAddRemoveFilterEvent({
                            eventType: items[0].isRefined ? "remove" : "add",
                            searchState: searchState,
                            filter: {
                              type: attribute,
                              value: stringInputValue.toString(),
                            },
                          });
                          refine([stringInputValue.toString()]); // is should be string ["false"]
                          setInputValue(items[0]?.isRefined);
                        }}
                        onBlur={() => {
                          console.log("");
                        }}
                      />
                    </StyledToggleSwitchBox>
                  </StyledContainer>
                )}
          </>
        ),
      [items]
    );
  }
);
